export default __webpack_public_path__ + "static/media/TM.98bb0a60.svg";